<template>
  <div class="list-box">
    <ul class="list-search">
      <el-space wrap style="flex: 1">
        <el-input
          v-model="state.params.keywords"
          style="width: 200px"
          placeholder="名称、统一社会信用代码"
          clearable
          @clear="
            delete state.params.keywords;
            onLoad();
          "
          @paste.enter="$onKeywordsPaste($event, state.params)"
        ></el-input>
        <el-tree-select
          v-model="state.params.d_industry_id"
          :data="state.industryData"
          node-key="id"
          clearable
          accordion
          :props="{ label: 'name' }"
          :render-after-expand="false"
          :highlight-current="true"
          :default-expand-all="true"
          :check-strictly="true"
          placeholder="--所属行业--"
          @clear="delete state.params.d_industry_id"
          filterable
          style="width: 200px"
        >
          <template #default="{ data }">
            <div style="display: flex; align-items: center">
              {{ data.name }}
            </div>
          </template>
        </el-tree-select>
        <el-select
          v-model="state.params.tax_bureau_id"
          @clear="delete state.params.tax_bureau_id"
          style="width: 200px"
        >
          <el-option
            v-for="item in state.taxbureauData"
            :key="item"
            :label="item.name"
            :value="item.id"
          />
        </el-select>
        <el-dropdown split-button @click="onLoad" type="primary">
          查询
          <template #dropdown>
            <el-dropdown-menu>
              <el-dropdown-item :icon="RefreshLeft" @click="onReset()">
                重置
              </el-dropdown-item>
            </el-dropdown-menu>
          </template>
        </el-dropdown>
      </el-space>
      <li style="margin-right: 10px; margin-top: 2px">
        您已选择：<strong style="color: #f00">{{ onSelectCount() }}</strong
        >条数据
      </li>
      <el-button type="success" @click="onSubmit">完成选择</el-button>
    </ul>
    <ul class="list-table">
      <el-table
        :data="state.tableData"
        ref="tableDom"
        v-loading="!Array.isArray(state.tableData)"
        element-loading-background="rgba(0, 0, 0, 0.2)"
        :default-sort="{
          prop: state.params.sort_field,
          order: state.params.sort_value == 'desc' ? 'descending' : 'ascending',
        }"
        @sort-change="onSortChange"
        @row-click="onRowClick"
      >
        <el-table-column type="selection" width="55" fixed />
        <el-table-column
          fixed
          label="序号"
          width="70"
          type="index"
          align="center"
        />
        <el-table-column
          prop="name"
          label="企业名称"
          :formatter="$tab_TextFormat"
          :min-width="180"
        />
        <el-table-column
          prop="unified_social_credit_identifier"
          label="统一社会信用代码"
          width="200"
        >
          <template #default="{ row }">
            <text
              style="color: #1e90ff"
              class="text-hover-decoration"
              title="证件号"
              @click="$onCopy(row.unified_social_credit_identifier)"
            >
              {{ row.unified_social_credit_identifier }}
            </text>
          </template>
        </el-table-column>
        <el-table-column
          prop="tax_bureau_name"
          label="所属税局"
          :formatter="$tab_TextFormat"
          :min-width="180"
        />
        <el-table-column
          label="所属行业"
          sortable="status"
          prop="d_industry_name"
          :formatter="$tab_TextFormat"
          :min-width="140"
        />
        <el-table-column
          prop="name"
          label="所在地址"
          :formatter="
            (row) =>
              $tab_GroupFormat(
                row.province + (row.city || '') + (row.district || ''),
                row.address || ''
              )
          "
          :min-width="220"
        />
      </el-table>
    </ul>
  </div>
</template>

<script>
import { onMounted, reactive, ref } from "vue";
import { data_withholdingagent_page } from "@/http/data";
import { industry_tree } from "@/http/dictionary";
import { data_taxbureau_select } from "@/http/data";

class InitFormData {
  params = {
    limit: 0,
  };
}
export default {
  props: {
    selectItems: Array,
  },
  setup(props, { emit }) {
    const tableDom = ref(null);
    const state = reactive(new InitFormData());
    onMounted(() => {
      onLoad();
      onLoadTaxBureauData();
      onLoadIndustry();
    });

    const onLoad = () => {
      delete state.tableData;
      data_withholdingagent_page(state.params).then((res) => {
        if (res.status == 200) {
          const { list } = res.data.data;
          state.tableData = list;

          setTimeout(() => {
            list.forEach((e) => {
              if (props.selectItems?.some((w) => w.id == e.id))
                tableDom.value.toggleRowSelection(e);
            });
          }, 300);
        }
      });
    };

    //获取税局
    const onLoadTaxBureauData = () => {
      data_taxbureau_select().then((res) => {
        if (res.status == 200) state.taxbureauData = res.data.data?.list;
      });
    };

    //获取行业树
    const onLoadIndustry = () => {
      industry_tree().then((res) => {
        if (res.status == 200) state.industryData = res.data.data;
      });
    };

    //排序
    const onSortChange = ({ column }) => {
      if (column.order) {
        state.params.sort_field = column.sortable;
        state.params.sort_value = column.order === "ascending" ? "asc" : "desc";
      } else {
        const params = new InitFormData().params;
        state.params.sort_field = params.Order;
        state.params.sort_value = "asc";
      }
      onLoad();
    };

    //重置查询条件
    const onReset = () => {
      Object.assign(state, new InitFormData());
      onLoad();
    };

    //表格行点击事件
    const onRowClick = (row) => {
      tableDom.value.toggleRowSelection(row);
    };

    const onSelectCount = () => {
      return tableDom.value?.getSelectionRows()?.length || 0;
    };

    const onSubmit = () => {
      const rows = tableDom.value.getSelectionRows();
      emit("close", rows);
    };

    return {
      state,
      tableDom,
      onLoad,
      onSortChange,
      onReset,
      onLoadTaxBureauData,
      onLoadIndustry,
      onRowClick,
      onSelectCount,
      onSubmit,
    };
  },
};
</script>
<style scoped></style>
